import Experiments from '@/api/experiments/experiments.js'
import fileDownload from 'js-file-download'
import router from '@/router'
import localforage from 'localforage'
import { getCachedImage } from '@/utils/imageCache'

// Initialize localForage for image caching
localforage.config({
  driver: localforage.INDEXEDDB, // Can be localStorage, WebSQL, or IndexedDB
  name: 'experimentCache',
})

const experiments = new Experiments()

const experimentsModule = {
  namespaced: true,
  state: {
    items: [],
    item: null,
    lookups: [],
    experimentsLookups: [],
    subExperimentsLookups: [],
    total: 0,
    load: false,
    loadItem: false,
    statusLookups: [],
    rands: [],
    randLoad: false,
    loadedImages: {},
  },
  getters: {
    rands(state) {
      return state.rands
    },
    randLoad(state) {
      return state.randLoad
    },
    experimentsLookups(state) {
      return state.experimentsLookups
    },
    items(state) {
      return state.items
    },
    item(state) {
      return state.item
    },
    load(state) {
      return state.load
    },
    loadItem(state) {
      return state.loadItem
    },
    total(state) {
      return state.total
    },
    statusLookups(state) {
      return state.statusLookups
    },
    lookups(state) {
      return state.lookups
    },
    // subExperimentsLookups(state) {
    //   return state.subExperimentsLookups;
    // },
  },
  mutations: {
    SET_RANDS(state, rands) {
      state.rands = rands
    },
    SET_RAND_LOAD(state, load) {
      state.randLoad = load
    },
    SET_EXPERIMENTS_LOOKUPS(state, experimentsLookups) {
      state.experimentsLookups = experimentsLookups
    },
    SET_ITEMS: (state, experiments) => {
      state.items = experiments
    },
    SET_STATUS_LOOKUPS: (state, statusLookups) => {
      state.statusLookups = statusLookups
    },
    SET_TOTAL_EXPERIMENTS: (state, total) => {
      state.total = total
    },
    SET_ITEMS_LOAD: (state, load) => {
      state.load = load
    },
    SET_ITEM: (state, item) => {
      state.item = item
    },
    SET_LOAD_ITEM: (state, loadItem) => {
      state.loadItem = loadItem
    },
    SET_LOOKUPS(state, lookups) {
      state.lookups = lookups
    },
    // SET_SUBEXPERIMENTS_LOOKUPS(state, lookups) {
    //   state.subExperimentsLookups = lookups;
    // },
    SET_LOADED_IMAGES(state, { experimentId, imageUrls }) {
      // Initialize the array if it doesn't exist for the experiment ID
      if (!state.loadedImages[experimentId]) {
        state.loadedImages[experimentId] = []
      }

      // Add new image URLs to the loaded images array
      state.loadedImages[experimentId] = [...new Set([...state.loadedImages[experimentId], ...imageUrls])]
    },
  },
  actions: {
    list({ commit, state }, query) {
      return new Promise((resolve, reject) => {
        commit('SET_ITEMS_LOAD', true)
        experiments.list(query).then(response => {
          commit('SET_ITEMS', response)
          commit('SET_TOTAL_EXPERIMENTS', response.meta.total)
          response.data.forEach(async experiment => {
            if (experiment.image) {
              experiment.cachedImage = await getCachedImage(experiment.image)
            }
            // if (experiment.images?.length) {
            //   const cachedImgs = [];
            //   for (const img of experiment.images) {
            //     cachedImgs.push(await getCachedImage(img.url));
            //   }
            //   experiment.cachedImages = cachedImgs;
            // }
          })
          commit('SET_ITEMS_LOAD', false)
          resolve(response)
        })
      })
    },
    getVersions({ commit }, id) {
      return new Promise((resolve, reject) => {
        experiments
          .getVersions(id)
          .then(response => {
            resolve(response)
          })
          .catch(error => reject(error))
      })
    },

    RandExperiments({ commit }) {
      return new Promise((resolve, reject) => {
        commit('SET_RAND_LOAD', true)
        experiments.RandExperiments().then(response => {
          commit('SET_RANDS', response)
          commit('SET_RAND_LOAD', false)
          resolve(response)
        })
      })
    },
    getExpId({ commit }, payload) {
      return new Promise((resolve, reject) => {
        experiments
          .getExpId(payload.query)
          .then(response => {
            resolve(response)
          })
          .catch(error => {
            reject(error)
          })
      })
    },
    put({ commit }, payload) {
      return new Promise((resolve, reject) => {
        experiments
          .put(payload)
          .then(response => {
            resolve(response)
          })
          .catch(error => {
            reject(error)
          })
      })
    },
    update({ commit }, payload) {
      return new Promise((resolve, reject) => {
        experiments
          .update(payload)
          .then(response => {
            resolve(response)
          })
          .catch(error => {
            reject(error)
          })
      })
    },

    filter({ commit }, id) {
      return new Promise((resolve, reject) => {
        experiments
          .filter(id)
          .then(response => {
            commit('SET_ITEMS', response.data.data)

            resolve(response)
          })
          .catch(error => {
            reject(error)
          })
      })
    },
    statusLookups({ commit }) {
      return new Promise((resolve, reject) => {
        experiments.statusLookups().then(response => {
          commit('SET_STATUS_LOOKUPS', response.data)
          resolve(response)
        })
      })
    },
    experimentsLookups({ commit }) {
      return new Promise((resolve, reject) => {
        experiments
          .experimentsLookups()
          .then(response => {
            commit('SET_EXPERIMENTS_LOOKUPS', response)
            resolve(response)
          })
          .catch(error => {
            reject(error)
          })
      })
    },
    // subExperimentsLookups({ commit }) {
    //   return new Promise((resolve, reject) => {
    //     experiments.subExperimentsLookups().then((response) => {
    //       commit("SET_SUBEXPERIMENTS_LOOKUPS", response.topic_types);
    //       resolve();
    //     });
    //   });
    // },
    get({ commit, dispatch }, id) {
      return new Promise((resolve, reject) => {
        commit('SET_LOAD_ITEM', true)
        experiments
          .get(id)
          .then(response => {
            commit('SET_ITEM', response.data)
            commit('SET_LOAD_ITEM', false)
            resolve(response)
          })
          .catch(error => {
            reject(error)
            commit('SET_LOAD_ITEM', false)
          })
      })
    },
    remove({ commit }, id) {
      return new Promise((resolve, reject) => {
        experiments
          .remove(id)
          .then(response => {
            resolve(response)
          })
          .catch(error => {
            reject(error)
          })
      })
    },
    restore({ commit }, id) {
      return new Promise((resolve, reject) => {
        experiments
          .restore(id)
          .then(response => {
            resolve(response)
          })
          .catch(error => {
            reject(error)
          })
      })
    },
    order({ commit }, payload) {
      return new Promise((resolve, reject) => {
        experiments
          .order(payload)
          .then(response => {
            resolve(response)
          })
          .catch(error => {
            reject(error)
          })
      })
    },
    watched({ commit }, payload) {
      return new Promise((resolve, reject) => {
        experiments
          .watched(payload)
          .then(response => {
            resolve(response)
          })
          .catch(error => {
            reject(error)
          })
      })
    },
    hardRemove({ commit }, id) {
      return new Promise((resolve, reject) => {
        experiments
          .hardRemove(id)
          .then(response => {
            resolve(response)
          })
          .catch(error => {
            reject(error)
          })
      })
    },
    getStudentProgressLog({ commit }, payload) {
      return new Promise((resolve, reject) => {
        experiments
          .getStudentProgressLog(payload)
          .then(response => {
            resolve(response)
          })
          .catch(error => {
            reject(error)
          })
      })
    },
    toggleFeatured({ commit }, payload) {
      return new Promise((resolve, reject) => {
        experiments
          .toggleFeatured(payload)
          .then(response => {
            resolve(response)
          })
          .catch(error => {
            reject(error)
          })
      })
    },
  },
}

export default experimentsModule
